import React from 'react';

import classNames from 'classnames';

interface EmptyStateProps {
    icon?: React.ComponentType<{ className?: string }>;
    title: string;
    description?: React.ReactNode;
    action?: React.ReactNode;
    size?: 'sm' | 'md';
    className?: string;
}

const EmptyState: React.FC<EmptyStateProps> = ({ icon: Icon, title, description, action, size = 'md', className }) => {
    return (
        <div
            className={classNames(
                'flex flex-col items-center justify-center text-center',
                size === 'md' ? 'py-14 px-6' : 'py-8 px-4',
                className,
            )}
        >
            {Icon && (
                <div className="flex items-center justify-center w-12 h-12 mb-4 rounded-xl bg-slate-100 dark:bg-slate-800 ring-1 ring-inset ring-slate-200 dark:ring-slate-700">
                    <Icon className="w-6 h-6 text-slate-400 dark:text-slate-500" />
                </div>
            )}
            <h3 className="text-sm font-semibold text-slate-900 dark:text-white">{title}</h3>
            {description && <p className="mt-1 text-sm text-slate-500 dark:text-slate-400 max-w-sm">{description}</p>}
            {action && <div className="mt-4">{action}</div>}
        </div>
    );
};

export default EmptyState;
